import React, { ReactElement } from "react"

import classNames from "classnames";

const ICON_CHEVRON_RIGHT_IN_CIRCLE = "/assets/icons/ic-chevron-right-in-circle.svg";


/**
 * types: `(href != null)` ? `<Link>` : `<div onClick>`
 * @param props.containerClass - ex) "px-[??] py-[??]"
 * @param props.iconContainerClass - ex) "right-[??]"
 * @param props.iconClass - ex) "w-[??] h-[??]"
 */
const ButtonCommonJapan = (props:{
  renderContent:() => ReactElement
  onClick?:any
  href?:string
  width?:number
  containerClass?:string
  iconContainerClass?:string
  iconClass?:string
}) => {
  const baseContainerClass = "flex justify-between items-center rounded-full bg-[#FF0099]";

  const renderChildren = () => {
    return (
      <>
        <div className="flex-grow flex justify-center">
          {props.renderContent()}
        </div>
        <div 
          className={classNames([
            "h-100",
            props.iconContainerClass != null ? props.iconContainerClass : ""
          ])}
        >
          <img
            src={ICON_CHEVRON_RIGHT_IN_CIRCLE}
            alt="ic-chevron-right-in-circle"
            className={props.iconClass != null ? props.iconClass : ""}
          />
        </div>
      </>
    )
  }


  if (props.href != null) {
    return (
      <a
        href={props.href}
        className={classNames([
          baseContainerClass,
          props.containerClass != null ? props.containerClass : ""
        ])}
      >
        {renderChildren()}
      </a>
    );
    
  } else {
    return (
      <div
        className={classNames([
          baseContainerClass,
          "select-none cursor-pointer",
          props.containerClass != null ? props.containerClass : ""
        ])}
        onClick={props.onClick}
      >
        {renderChildren()}
      </div>
    );
  }

}

export default ButtonCommonJapan
